var map = {
	"./NIRF_2020 Engineering Category Ranking 130.pdf": 37366,
	"./NIRF_2021 Engineering Category Ranking 164.pdf": 51694,
	"./NIRF_2022 Engineering Category Ranking 118.pdf": 59994,
	"./NIRF_2023  Engineering Category Bandwith 101-150.pdf": 92075,
	"./NIRF_2023 Innvoation Category Bandwith 51-100.pdf": 78856,
	"./NIRF_2024  Engineering Category Bandwith 101-150.pdf": 21198,
	"./NIRF_2025  Engineering Category Bandwith 101-150.pdf": 72069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56565;